<template>
    <div class="country-pl" :class="$x.nsAddressForm">
        <VTextField
            v-model="address.address1"
            name="address1"
            maxlength="40"
            required
            validate-on-blur
            :label="t.address1Label"
            class="flex-column"
            :rules="address1Rules"
            @blur="onBlur"
            @input="addressUpdated"
        ></VTextField>
        <VTextField
            v-model="address.address2"
            name="address2"
            maxlength="35"
            validate-on-blur
            :label="t.address2Label"
            class="flex-column"
            :rules="address2Rules"
            @blur="onBlur"
            @input="addressUpdated"
        ></VTextField>
        <div :class="$x.dualColumn">
            <VTextField
                v-model="address.city"
                name="city"
                maxlength="100"
                required
                validate-on-blur
                :label="t.cityLabel"
                :class="$x.firstCol"
                class="flex-column"
                :rules="cityRules"
                @blur="onBlur"
                @input="addressUpdated"
            ></VTextField>
            <VTextField
                v-model="address.postalCode"
                name="postalCode"
                maxlength="15"
                required
                validate-on-blur
                :label="t.postalCodeLabel"
                class="flex-column"
                :rules="postalCodeRules"
                @blur="onBlur"
                @input="addressUpdated"
            ></VTextField>
        </div>
        <VTextField
            v-if="includeEmail"
            v-model="address.email"
            name="email"
            maxlength="50"
            required
            validate-on-blur
            :label="t.emailLabel"
            class="flex-column"
            :rules="emailRules"
            @input="addressUpdated"
            @blur="onBlur"
        ></VTextField>
    </div>
</template>

<script>
import { VTextField } from 'vuetify/lib';
import ADDRESS_MIXIN from '../addressMixin';
// Most of the logic for this component is in the mixin
import TRANSLATIONS from './translations';

export default {
    name: 'NsAddressPl',
    components: {
        VTextField,
    },
    mixins: [ADDRESS_MIXIN],
    mounted() {
        this.address.country = 'PL';
        if (TRANSLATIONS[this.lang]) {
            this.t = TRANSLATIONS[this.lang];
        } else {
            // If the language isn't available then get the first language in translations file
            this.t = TRANSLATIONS[Object.keys(TRANSLATIONS)[0]];
        }
        this.$emit('new-address-in-form');
    },
    methods: {},
};
</script>

<style lang="scss" module="$x">
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/typographyVariables";

::v-deep *:not(.v-icon) {
  font-family: map.get(typographyVariables.$typography, font-family-primary);
}

.nsAddressForm {
  .dualColumn {
    display: flex;
    align-content: space-between;
    .firstCol {
      margin-right: 20px;
    }
  }
}
</style>
